<script setup>
import {onMounted, ref} from 'vue';
import Modal from '@Components/Modal/Modal';
import TipModify from "../Components/TipModify.vue";
import TipExplanation from "../Components/TipExplanation.vue";

const openModal = ref('');
const tip = ref(0);
const total = ref(0);
const min = ref(0);
const max = ref(0);
const schedule = ref(false);
const close = (e) => {
    if (typeof e !== 'undefined') {
        document.querySelector('.form-withProgress__grand-total .total-amount-price > span').innerHTML = memboGo.core.money.convert(e.totalWithTip);
        document.querySelector('.js-payment-tip-amount > span').innerHTML = memboGo.core.money.convert(e.tip);
        document.querySelector('[name="tip_amount"]').value = e.tip;
        memboGo.core.event.dispatch('display-split-payment-schedule', {});
    }
    openModal.value = ''
};
onMounted(() => {
    document.addEventListener('payment-tip-open-modal', (e) => {
        min.value = parseInt(e.detail.min || 0);
        max.value = parseInt(e.detail.max || 0);
        tip.value = parseFloat(e.detail.amount || 0);
        total.value = parseFloat(e.detail.total || 0);
        schedule.value = e.detail.schedule || false;
        openModal.value = 'tip';
    });
    document.addEventListener('payment-tip-explanation-modal', () => {
        openModal.value = 'explain';
    });
});

</script>
<template>
    <Modal :open="openModal !== ''" :close-click-outside="openModal !== 'tip'" @close="close">
        <TipModify
            v-if="openModal === 'tip'"
            :total="total"
            :tip="tip"
            :max="max"
            :min="min"
            :schedule="schedule"
            @close="close"/>
        <TipExplanation v-else/>
    </Modal>
</template>
<style lang="scss">
.v-modal-container {
    z-index: 9999;

    .v-modal-content {
        max-width: 680px;
    }
}
</style>